export default "__VITE_ASSET__451d624e__"